import Component from "@ember/component"
import { computed, get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { inject as service } from "@ember/service"
import type { TypeToModel } from "@shared/models/type-to-model"
import type EmberStore from "cc-frontend/services/ember-store"
import { Promise } from "rsvp"

export default class UnitRowProvider extends Component {
  //args
  unitId!: string

  // state
  _lastProxy: any = null
  _lastId: string | null = null

  // services
  @service("ember-store") store!: EmberStore

  @computed("unitId")
  get cardStack() {
    class ObjectPromiseProxy extends ObjectProxy.extend(PromiseProxyMixin) {}

    let id = get(this, "unitId")
    let model: keyof TypeToModel = "card-stack-summary"

    if (id === this._lastId && this._lastProxy) return this._lastProxy

    this._lastId = id
    let promise =
      id === null || id === undefined
        ? new Promise((resolve, reject) => resolve(null))
        : get(this, "store").find(model, id)

    this._lastProxy = ObjectPromiseProxy.create({
      promise: promise,
    })

    return this._lastProxy
  }
}
